import { useTranslation } from 'react-i18next'
import { Box, FormControl, Select, MenuItem, Typography } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'

import { StateSchema } from '@/hooks/form/models'
import keys from '@/utils/keys'
import { BonusPeriodRecurrenceEnum } from '@/enums/be-bonus-period.enum'

import { menuProps } from '@/constants/mui'
import DailyPeriodComponent from './daily.component'
import DateRangeComponent from './date-range.component'

import WeekdayPeriodComponent from './weekday.component'

type Props = {
  state: StateSchema
  handleOnChange: (name: string, value: any) => void
}

const BonusPeriodComponent = ({ state, handleOnChange }: Props) => {
  const { t } = useTranslation()

  const bonusPeriodType = [
    ...keys(BonusPeriodRecurrenceEnum).map((x) => {
      return {
        index: BonusPeriodRecurrenceEnum[x],
        label: x,
      }
    }),
  ].sort((a, b) => a.label.localeCompare(b.label))

  return (
    <>
      <Box my={2} mb={3} maxWidth={400}>
        <Typography fontWeight={700}>{t('bonusPeriod')}</Typography>
        <Box mt={2}>
          <Typography variant="body2" gutterBottom>
            {t('bonusPeriodMessage')}
          </Typography>
        </Box>
        <FormControl margin="dense" fullWidth>
          <Select
            id="recurrence"
            name="recurrence"
            value={state.recurrence.value || ''}
            onChange={(e: any) => handleOnChange('recurrence', e.target.value)}
            IconComponent={KeyboardArrowDown}
            displayEmpty
            MenuProps={menuProps}
          >
            <MenuItem value="" disabled>
              <Box fontStyle="italic">{t('bonusPeriodLabel')}</Box>
            </MenuItem>
            <MenuItem value="noPeriod">
              <Box fontStyle="italic">{t('noPeriod')}</Box>
            </MenuItem>
            {(bonusPeriodType || []).map((item) => (
              <MenuItem key={item.index} value={item.index}>
                {t(`bonusPeriodType.${item.label}`)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {(state.recurrence.value === BonusPeriodRecurrenceEnum.daily ||
          state.recurrence.value === BonusPeriodRecurrenceEnum.weekday) && (
          <DailyPeriodComponent state={state} handleOnChange={handleOnChange} />
        )}
        {state.recurrence.value === BonusPeriodRecurrenceEnum.dateRange && (
          <DateRangeComponent state={state} handleOnChange={handleOnChange} />
        )}
        {state.recurrence.value === BonusPeriodRecurrenceEnum.weekday && (
          <WeekdayPeriodComponent
            state={state}
            handleOnChange={handleOnChange}
          />
        )}
      </Box>
    </>
  )
}

export default BonusPeriodComponent
